<template><div><h1 id="reportingtool" tabindex="-1"><a class="header-anchor" href="#reportingtool"><span>Reportingtool</span></a></h1>
<p>Reportingtool — Definiert die Quelle und die Achsengruppierungen einer Reportingtool-Auswertung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In &quot;Reportingtool&quot; werden die folgenden Daten einer Reportingtool-Auswertung gesetzt:</p>
<ul>
<li>
<p>Die Quelle</p>
</li>
<li>
<p>Eine mögliche Einschränkung der Daten mittels einem Filter</p>
</li>
<li>
<p>Die Achsen und ihre Gruppierungen</p>
</li>
</ul>
<p>Weiter dient die Struktur zur Protokollierung der Ausgabeoptionen für die letzte Ausführung des Jobs.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Reporting-Tool</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Job/Laufnr</dt>
<dd>Erfassungsdatum, System vergibt automatisch eine Laufnummer bei der Erfassung mehrerer Auswertungen pro Tag.</dd>
<dt>Quelle</dt>
<dd>Basis der Auswertung, entweder A = Adressen, L = Artikel oder W = Aufträge. Abhängig von dieser Auswahl verändert sich das Set der wählbaren Gruppierungen.</dd>
<dt>Bezeichnung</dt>
<dd>freies Textfeld zur Identifikation der Auswertung.</dd>
<dt>L-Datum:</dt>
<dd>Letztes Laufdatum, an dem die Auswertung gelaufen ist. Jede definierte Auswertung kann mehrfach gestartet werden.</dd>
<dt>Status</dt>
<dd>Status der Auswertung. Die folgenden Stati sind möglich:
<table>
<thead>
<tr>
<th>Status</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>erfasst</td>
</tr>
<tr>
<td>2</td>
<td>läuft gerade</td>
</tr>
<tr>
<td>3</td>
<td>abgeschlossen (Protokoll des Jobs bleibt im System)</td>
</tr>
</tbody>
</table>
</dd>
<dt>Ergebnisse nur für Adressfilter:</dt>
<dd>Eingrenzung des Universums nach Adressfilter</dd>
<dt>x-Achse Gruppierung</dt>
<dd>Nummer einer <a class="link" href="ft.refdata.tbldim.html" title="Dimension">Gruppierung </a>. Nur Gruppierungen, die auch für die entsprechende Quelle definiert sind, können gesetzt werden.</dd>
<dt>x-Achse Parameter</dt>
<dd>Parameter der Gruppierung. Das Format der Parameter ist bei den Gruppierungsdimensionen in <a class="xref" href="ft.refdata.tbldim.html" title="Dimension"><span class="refentrytitle">Dimension</span></a> beschrieben.</dd>
<dt>y-Achse Gruppierung</dt>
<dd>Wie bei x-Achse</dd>
<dt>Parameter</dt>
<dd>Wie bei x-Achse</dd>
<dt>Drucker</dt>
<dd>Anzeige des Druckers, auf den bei der letzen Ausführung ausgegeben wurde.</dd>
<dt>Dateiname</dt>
<dd>Anzeige der Datei, in die die letzte Ausgabe geschrieben wurde.</dd>
<dt>Format</dt>
<dd>Anzeige des Formats, in dem die letzte Ausgabe erstellt wurde. (Für Codes siehe <a class="xref" href="ft.refproc.rt.html" title="Reportingtool-Auswertung"><span class="refentrytitle">Reportingtool-Auswertung</span></a> )</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="kopie" tabindex="-1"><a class="header-anchor" href="#kopie"><span>Kopie</span></a></h3>
<p>Erlaubt das Kopieren einer Reportingtool-Auswertungsdefinition inklusive Ergebnistabellen.</p>
<h3 id="vorbe-druck" tabindex="-1"><a class="header-anchor" href="#vorbe-druck"><span>Vorbe/druck</span></a></h3>
<p>Führt eine Reportingtool Auswertung durch. Siehe <RouteLink to="/referenz/refs/ft.refproc.rt.html" title="Reportingtool-Auswertung">Reportingtool-Auswertung</RouteLink> .</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/reportingtool.html" title="9. Reportingtool">Reportingtool</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.tbldim.html" title="Dimension">Gruppierungen</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.rtresult.html" title="Ergebnistabelle">Ergebnistabelle</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.rt.html" title="Reportingtool-Auswertung">Auswertung</RouteLink></p>
</div></template>


